import "bootstrap/dist/css/bootstrap.min.css";
import React, { Suspense } from "react";
import { Container, Spinner } from "react-bootstrap";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import "./assets/css/fontStyle.css";
import "./assets/css/style.css";
import Accessory from "./screens/Accessories/Accessory";
import AccessoryDetail from "./screens/Accessories/AccessoryDetail";
import CompletedAppointments from "./screens/admin/appointments/Completed";
import UpcomingAppointments from "./screens/admin/appointments/UpComing";
import Login from "./screens/admin/auth/Login";
import ManageBrand from "./screens/admin/Brand/ManageBrand";
import ManageCategory from "./screens/admin/Category/ManageCategory";
import Dashboard from "./screens/admin/dashboard/Dashboard";
import ManageSlider from "./screens/admin/HomeSlider/ManageSlider";
import ManagePost from "./screens/admin/Posts/ManagePost";
import ManageProduct from "./screens/admin/Product/ManageProduct";
import CustomerSignin from "./screens/auth/CustomerSignin";
import CustomerSignup from "./screens/auth/CustomerSignup";
import Mobiles from "./screens/Mobiles/Mobiles";
import ProductDetail from "./screens/Product/ProductDetail";
import Post from "./screens/posts/Post";
import PostDetails from "./screens/posts/PostDetails";
import Cart from "./screens/Cart/Cart";
import PaymentVerification from "./screens/Payment/PaymentVerification";
import CompleteOrders from "./screens/admin/Orders/CompleteOrders";
import OngoingOrders from "./screens/admin/Orders/OngoingOrders";
import WalkinOngoing from "./screens/admin/Walkin/WalkinOngoing";
import WalkinComplete from "./screens/admin/Walkin/WalkinComplete";

const Home = React.lazy(() => import("./screens/home/HomePage"));

function App() {
  return (
    <>
      <Suspense
        fallback={
          <Container
            fluid
            className="d-flex justify-content-lg-center align-items-center"
          >
            <Spinner
              animation="border"
              style={{ width: "50px", height: "50px" }}
            />
          </Container>
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mobiles" element={<Mobiles />} />
          <Route path="/product-details" element={<ProductDetail />} />
          <Route path="/accessories" element={<Accessory />} />
          
          <Route path="/posts" element={<Post />} />
          <Route path="/post/:slug" element={<PostDetails />} />
          <Route path="/customer-login" element={<CustomerSignin />} />
          <Route path="/customer-signup" element={<CustomerSignup />} />
          <Route path="/admin" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/walkin-ongoing" element={<WalkinOngoing />} />
          <Route path="/walkin-complete" element={<WalkinComplete />} />
          <Route path="/sliderManagement" element={<ManageSlider />} />
          <Route path="/brands" element={<ManageBrand />} />
          <Route path="/categories" element={<ManageCategory />} />
          <Route path="/products" element={<ManageProduct />} />
          <Route path="/ongoing-orders" element={<OngoingOrders />} />
          <Route path="/completed-orders" element={<CompleteOrders />} />
          <Route path="/products" element={<ManageProduct />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<PaymentVerification />} />
          <Route
            path="/appointments-upcoming"
            element={<UpcomingAppointments />}
          />
          <Route
            path="/appointments-completed"
            element={<CompletedAppointments />}
          />
          <Route path="/postManagement" element={<ManagePost />} />
          <Route
            path="*"
            element={
              <div>
                <h1 className="poppins-bold">PAGE NOT FOUND.</h1>
              </div>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
